<template>
    <div>
        <div class="form-group row" :class="{ 'has-danger' : error != null }">
            <label :class="labelClasses" class="col-form-label" :for="name">{{ computedLabel }}</label>
            <div :class="inputHolderClasses">
                <multi-select
                    v-bind="$attrs"
                    :show-labels="false"
                    label="full_name"
                    @input="$emit('input', $event)"
                >
                    <template slot="option" slot-scope="{ option }" v-if="legend">
                        <b-badge pill variant="info">{{ option.distance_to_candidate }} km</b-badge>
                        <i v-if="option.max_trajectories_reached == true" class="fa fa-lg fa-lock"></i>
                        <i v-if="option.unavailable == true" class="fa fa-lg fa-plane"></i>
                        <span class="option__title">
                          <strong>{{ option.full_name }}</strong>
                          <span v-if="option.addresses.length > 0"  v-for="address in option.addresses">
                              <strong> | </strong>
                              <small>
                                {{ address.street }} {{ address.house_number }}, {{ address.city }}
                              </small>
                          </span>
                        </span>
                    </template>
                </multi-select>
                <span class="help-block form-control-feedback" v-if="error != null" v-text="error"></span>
            </div>
            <div v-if="legend" class="col-md-12 text-right text-muted">
                <small>
                    {{ uLang('app.legend') }}:
                    <span class="icon-holder">
                        <i class="fa fa-lg fa-lock" :title="uLang('app.max_trajectories_reached')"></i>
                        <i class="fa fa-lg fa-plane" :title="uLang('app.coach_unavailable_at_starting_date')"></i>
                    </span>
                </small>
            </div>
        </div>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect'

    export default {
        name: 'trajectory-manager-select',
        components: {
            MultiSelect,
        },

        props: {
            name: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: false,
            },
            labelClasses: {
                type: String,
                required: false,
                default: 'col-md-3 col-xl-2 col-sm-12',
            },
            inputHolderClasses: {
                type: String,
                required: false,
                default: 'col-md-9 col-xl-10 col-sm-12'
            },
            error: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            },
            autofocus: {
                type: Boolean,
                default: false,
            },
            legend: {
                type: Boolean,
                default: true,
            },
            candidate: {
                type: Number,
                required: false,
            }
        },

        computed: {
            computedLabel: function () {
                let label = this.label ? this.label : this.name;

                return this.uLang('app.' + label) + (this.required ? ': *' : ': ');
            }
        },
    }
</script>

<style lang="scss">
.icon-holder {
    padding-left: 10px;
    i {
        padding-right: 10px;
    }
}
</style>
